import React from "react";
import AuthModalHeader from "./auth/AuthModalHeader";
import AuthForm from "./auth/AuthForm";
import AuthProviders from "./auth/AuthProviders";
import AuthFooter from "./auth/AuthFooter";
import { ResponsiveModal } from "./ResponsiveModal/ResponsiveModal";
import { PlanSignupChoice } from "./plans/PlanSignupChoice";
import { planById, type PlanId } from "@/lib/plans";
interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "login" | "signup";
  onModeChange: (mode: "login" | "signup") => void;
  initialPlan?: PlanId;
}
const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  mode,
  onModeChange,
  initialPlan,
}) => {
  const [plan, setPlan] = React.useState<PlanId>(initialPlan ?? "free");
  const [step, setStep] = React.useState<"plan" | "account">("plan");
  React.useEffect(() => {
    if (isOpen) {
      setPlan(initialPlan ?? "free");
      setStep("plan");
    }
  }, [isOpen, initialPlan]);
  function changeMode(next: "login" | "signup") {
    setStep("plan");
    onModeChange(next);
  }
  const choosing = mode === "signup" && step === "plan";
  return (
    <ResponsiveModal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={mode === "signup" ? "Create your PokeLlama account" : "Sign in"}
      size={choosing ? "lg" : "md"}
      className="bg-gradient-to-br from-deep-indigo to-deep-indigo/90 border-holo-blue/20 text-white mx-auto"
    >
      <div>
        {choosing ? (
          <p className="mb-3 text-sm font-semibold text-cyan-200">
            Join the herd
          </p>
        ) : (
          <AuthModalHeader mode={mode} />
        )}
        {choosing ? (
          <PlanSignupChoice
            value={plan}
            onChange={setPlan}
            onContinue={() => setStep("account")}
            onCompare={onClose}
          />
        ) : (
          <>
            {mode === "signup" && (
              <div className="mt-4 rounded-xl border border-white/20 p-3 text-sm">
                <p>
                  Step 2 of 2 · {planById(plan).name}
                  {!planById(plan).available && " preference · starting Free"}
                </p>
                <button
                  className="mt-1 min-h-11 text-cyan-200 underline"
                  onClick={() => setStep("plan")}
                >
                  Change plan
                </button>
              </div>
            )}
            <AuthForm
              mode={mode}
              onModeChange={changeMode}
              onClose={onClose}
              selectedPlan={plan}
              preservePlan={mode === "signup" || initialPlan !== undefined}
            />
            <AuthProviders
              mode={mode}
              planIntent={
                mode === "signup" || initialPlan !== undefined
                  ? plan
                  : undefined
              }
            />
          </>
        )}
        <AuthFooter
          mode={mode}
          onModeChange={changeMode}
          onClose={onClose}
          loading={false}
        />
      </div>
    </ResponsiveModal>
  );
};
export default AuthModal;
